/**
 * @typedef {import("@prismicio/client").Content.PictureSlice} PictureSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<PictureSlice>} PictureProps
 * @param {PictureProps}
 */
const Picture = ({ slice, index }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-no-repeat bg-cover bg-center ${index !== 0 ? 'border-t-2 border-dark-grey' : ''} h-[308px] md:h-[475px]`}
      style={{ backgroundImage: `url(${slice.primary.picture.url})` }}
      aria-label={slice.primary.picture.alt}>
    </section>
  );
};

export default Picture;
